module.exports = __webpack_public_path__ + "static/media/figma.48aca6b0.svg";